import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'psm-email-action-handler',
    templateUrl: 'emailActionHandler.component.html',
    styleUrls: ['emailActionHandler.component.scss']
})

export class EmailActionHandlerComponent implements OnInit {
    public mode: string;
    public password: string;
    public actionCode: string;
    public apiKey: string;
    public continueUrl: string;

    constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService, private toasterService: ToasterService) { }

    public ngOnInit() {
        this.route.queryParams.subscribe(async values => {
            this.actionCode = values.oobCode;
            this.apiKey = values.apiKey;
            this.continueUrl = values.continueUrl;
            this.mode = values.mode;

            switch (this.mode) {
                case 'resetPassword':
                    break;

                case 'recoverEmail':
                    if (await this.authService.verifyEmail(this.actionCode)) {
                        await this.toasterService.popAsync('success', undefined, 'modules.user.email-action-handler.email-recovery-success');
                    }

                    this.router.navigateByUrl('/user/login');
                    break;

                case 'verifyEmail':
                    if (await this.authService.verifyEmail(this.actionCode)) {
                        await this.toasterService.popAsync('success', undefined, 'modules.user.email-action-handler.verify-email-success');
                    }

                    this.router.navigateByUrl('/user/login');
                    break;
            }
        });
    }

    public async changePassword() {
        if (await this.authService.changePassword(this.actionCode, this.password)) {
            this.toasterService.pop('success', undefined, 'modules.user.email-action-handler.password-reset-success');
            this.router.navigateByUrl('/');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/user/emailActionHandler.component.ts